<template>
    <div class="flex h-screen overflow-hidden">
        <Sidebar />
        <div class="flex-1 flex flex-col overflow-hidden">
            <Topbar />
            <main class="flex-1 overflow-auto p-4 lg:p-6 bg-surface-50 dark:bg-surface-950">
                <router-view />
            </main>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { provide, ref } from 'vue'
    import Sidebar from './components/Sidebar.vue'
    import Topbar  from './components/Topbar.vue'

    const mobileOpen = ref(false)
    provide('mobileOpen', mobileOpen)
    provide('toggleMobileMenu', () => { mobileOpen.value = !mobileOpen.value })
</script>
